<div class="fullCover">
<h1>404</h1>
<p>Something is wrong.</p>
<a class="button" routerLink="/"><i class="icon-home"></i> Go back to home page</a>

</div>